export { default as CompetitionGridBlock } from './CompetitionGridBlock';
export type { CompetitionGridBlockProps } from './CompetitionGrid.types';
